module.exports = __webpack_public_path__ + "static/media/bg-login.225e9587.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-login.jpg
// module id = 233
// module chunks = 0